import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as myGlobals from '../../globals';
import { Configuration } from '../../app.configuration';

declare var jQuery: any;
declare var $: any;
declare var google: any;

@Injectable()
export class TasksService {
  private _getBookingHistory = myGlobals.apiurl + 'customer/bookingHistory';
  private _getdataUrl = myGlobals.apiurl + 'customer/bookingDetails';
  private _cancelBOokingAfter =
    myGlobals.apiurl + 'customer/cancelBookingAfterAccept';
  private _cancelfees = myGlobals.apiurl + 'customer/cancellationFees';
  private _cancelreasons = myGlobals.apiurl + 'customer/cancellationReasonRide';
  private _cancelservice =
    myGlobals.apiurl + 'customer/cancelBookingAfterAccept';
  private _allbookings = myGlobals.apiurl + 'customer/bookings';

  constructor(private _http: HttpClient, private _conf: Configuration) {}

  // START UBER FOR ALL API FUNCTIONS
  getAllBooking(user: any) {
    const obj = {
      status: user.status,
      fromDate: user.fromDate,
      toDate: user.toDate,
      search: user.search
    };
    return this._http.post(
      this._allbookings + '/' + 3 + '/' + user.limit + '/' + user.skip,
      obj,
      { headers: this._conf.header }
    );
  }

  // get data
  getdata(user: any) {
    return this._http.get(this._getdataUrl + '/' + user.bookingId + '/' + 2, {
      headers: this._conf.header
    });
  }

  cancelreasons(user: any) {
    return this._http.get(this._cancelreasons, { headers: this._conf.header });
  }
  gethistory(user: any) {
    return this._http.get(this._getBookingHistory, {
      headers: this._conf.header
    });
  }
}
